function hasWindow() {
  return typeof window !== "undefined";
}

function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }

  return "#document";
}

function getWindow(node) {
  var _node$ownerDocument;

  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}

function getDocumentElement(node) {
  var _ref;

  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}

function isNode(value) {
  if (!hasWindow()) {
    return false;
  }

  return value instanceof Node || value instanceof getWindow(value).Node;
}

function isElement(value) {
  if (!hasWindow()) {
    return false;
  }

  return value instanceof Element || value instanceof getWindow(value).Element;
}

function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }

  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}

function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }

  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}

function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}

function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }

  const result = // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot || // DOM Element detected.
  node.parentNode || // ShadowRoot detected.
  isShadowRoot(node) && node.host || // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}

export { getComputedStyle, getDocumentElement, getNodeName, getParentNode, getWindow, isElement, isHTMLElement, isLastTraversableNode, isNode, isShadowRoot, isWebKit };